
  import { computed, defineComponent, PropType } from 'vue';
  import { Button, Icon, Typography } from '@voximplant/spaceui';
  import { $callDuration, activeCalls, CALL_STATUSES } from '@/store/calls';
  import { useStore } from 'effector-vue/composition';
  import { ActiveCall } from '@/types';
  import { timeFormat } from '@/lib/Helpers';
  import { useI18n } from 'vue-i18n';
  import { $settings } from '@/store/settings';

  const __default__ = defineComponent({
    name: 'CallInfo',
    components: { Typography, Button, Icon },
    props: {
      callData: {
        type: Object as PropType<ActiveCall>,
        required: true,
      },
      incomingCall: {
        type: Boolean,
        default: false,
      },
      activeCall: {
        type: Boolean,
        default: false,
      },
    },
    setup(props) {
      const duration = useStore($callDuration);
      const settings = useStore($settings);
      const calls = useStore(activeCalls);
      const { t } = useI18n();

      const currentCallDuration = computed(() => {
        if (!props.callData) return;
        const { id } = props.callData;
        return duration.value[id as string] || {};
      });
      const userColor = computed(() => props.incomingCall || settings.value.fullscreen);
      const errorText = computed(() =>
        CALL_STATUSES.includes(props.callData.status)
          ? t(`errors.${props.callData.status}`)
          : props.callData?.status
      );
      const callInfoWidth = computed(() => {
        if (!props.activeCall) return 'inherit';
        else if (calls.value.length - 1) return '57%';
        else return '85%';
      });

      return {
        t,
        currentCallDuration,
        timeFormat,
        userColor,
        errorText,
        callInfoWidth,
        settings,
      };
    },
  });

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "54fd9aa1": (_ctx.callInfoWidth)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__